var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirewall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "_x32_",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.034,
    y: 0.787,
    className: "st0",
    width: 155.35,
    height: 94.936
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.645,
    y: 0.787,
    className: "st0",
    width: 155.35,
    height: 94.936
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 112.959,
    className: "st0",
    width: 69.044,
    height: 94.936
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.34,
    y: 112.985,
    className: "st0",
    width: 155.35,
    height: 94.936
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M266.78,160.9l16.756-26.634l9.111,8.58c1.892-10.19,5.36-20.152,10.22-29.862h-43.916v60.279   C263.7,165.796,266.68,161.059,266.78,160.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M436.126,148.283c22.542,18.028,41.586,38.129,56.938,59.613h7.509v-94.936h-69.044v31.32   C433.046,145.611,434.47,146.959,436.126,148.283z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.034,
    y: 225.182,
    className: "st0",
    width: 155.35,
    height: 94.936
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 337.354,
    className: "st0",
    width: 69.044,
    height: 77.675
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M368.494,54.627c4.479,0,8.996,1.003,13.068,2.908c9.836,4.517,16.654,14.16,17.653,25.083l1.193,13.106h100.2   V0.787h-155.35V62.87c3.902-2.562,7.324-4.24,10.097-5.302C359.441,55.639,363.904,54.627,368.494,54.627z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M419.957,168.501c-29.116-23.278-40.498-48.985-44.873-67.266c-3.502-14.682-1.656-16.258-1.656-16.258   c-0.16-1.753-1.252-3.262-2.827-3.986c-1.606-0.75-3.456-0.599-4.888,0.405c0,0-5.66,1.222-14.838,10.139   c-20.936,20.328-44.616,54.228-29.023,100.583c16.756,49.743,7.897,60.144-0.864,59.47c-11.37-0.868-13.106-7.872-11.29-29.668   c2.107-25.479-20.999-47.232-20.999-47.232s-35.901,57.076-63.891,97.904c-16.545,24.13-24.471,54.809-24.471,82.799h-0.561   c0,86.044,69.761,155.822,155.827,155.822c86.078,0,155.822-69.778,155.822-155.822   C517.358,280.64,476.759,213.939,419.957,168.501z M355.872,467.335c-47.461,0-85.969-38.492-85.969-85.968   c0-16.157,4.488-31.286,12.238-44.198c6.688,24.855,29.372,43.169,56.352,43.169c32.204,0,58.332-26.11,58.332-58.315   c0-6.153-0.965-12.086-2.735-17.657c28.298,14.076,47.75,43.254,47.75,77.001C441.84,428.843,403.365,467.335,355.872,467.335z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M177.959,320.118c4.522-22.748,13.279-44.35,25.496-62.167c7.021-10.24,14.577-21.568,21.943-32.77h-52.752   v94.936H177.959z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M173.884,337.379H86.34v77.675h97.814c-6.536-18.719-10.27-38.744-10.27-59.664V337.379z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirewall);
export default __webpack_public_path__ + "static/media/firewall.15feba2011855285049d9567a1ed78dc.svg";
export { ForwardRef as ReactComponent };